import React from 'react';
import Footer from './Footer';
import Nav from './Nav';

const Layout = ({ children }) => {
  return (
    <>
      <Nav />
      <main className={'container-main'}>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
